import { Fragment } from "react";
import DashboardIoTC from "Components/Dashboard/Components/DashboardIoT";
import { Breadcrumb } from "antd";
import { useNavigate } from "react-router-dom";
// import DashboardMap from "../../Components/_Specific/Dashboard/Components/DashboardMap";
// import styles from './index.module.scss'
import { useTranslation } from "react-i18next";

const IoTGuage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <Fragment>
      {/* 建立麵包屑組件 */}
      <Breadcrumb style={{ marginBottom: "10px", marginLeft: "15px" }}>
        <Breadcrumb.Item style={{ fontWeight: 500, fontSize: 16 }}>
          {/* 點擊後跳轉回根路徑 */}
          <a href="/#" onClick={() => navigate("./")}>
            {t("ISMS.Dashboard")}
          </a>
        </Breadcrumb.Item>
        <Breadcrumb.Item style={{ color: "#1890ff", fontWeight: 500, fontSize: 16 }}>
          {t("ISMS.IoT_Device_Gauge")}
        </Breadcrumb.Item>
      </Breadcrumb>
      {/* 引入 DashboardIoTC 頁面*/}
      <DashboardIoTC />
    </Fragment>
  );
};

export default IoTGuage;
